
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { RetentionPolicy } from '@/components/admin/certificates/types';

export function usePolicyDeletion() {
  const { toast } = useToast();
  const [isDeleting, setIsDeleting] = useState(false);
  
  const deletePolicyMutation = async (policyId: string) => {
    setIsDeleting(true);
    try {
      const { error } = await supabase
        .from('retention_policies')
        .delete()
        .eq('id', policyId);
      
      if (error) throw error;
      
      toast({
        title: "Success",
        description: "Retention policy deleted successfully",
      });
      
      return true;
    } catch (error) {
      console.error('Error deleting retention policy:', error);
      toast({
        title: "Error",
        description: "Failed to delete retention policy",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsDeleting(false);
    }
  };
  
  const onDeletePolicy = (policyId: string) => {
    // We'll use the policy ID directly now instead of extracting it from the policy object
    if (confirm(`Are you sure you want to delete this retention policy?`)) {
      return deletePolicyMutation(policyId);
    }
    return Promise.resolve(false);
  };
  
  return {
    isDeleting,
    onDeletePolicy
  };
}
